<template>
  <div id="contenedor-eliminar-contrato-catalogo-conceptos">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar {{getTipo()}} </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar {{getTipo()}}? </span>
        <div>
          <span>{{catalogoConceptoEliminar.clave}}</span>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarCatalogoConcepto"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixCatalogo from './mixCatalogo';

export default {
  name: 'EliminarCatalogoConcepto',
  mixins: [mixCatalogo],
  props: {
    catalogoConceptoEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    getTipo() {
      switch (this.catalogoConceptoEliminar.tipo) {
        case 0:
          return 'la Partida';
        case 1:
          return 'la Subpartida';
        case 2:
          return 'el Concepto';
        default:
          return 'la Partida';
      }
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },

};
</script>

<style>

</style>
